<template>
    <!-- 司机-司机任务-统计 -->
    <el-dialog :visible.sync="show" :close-on-click-modal="false" :before-close="closeDialog" append-to-body width="85%">
        <div class="handle-box-search taskNew">
            <div class="handle-box" style="display: flex">
                <div style="width: 70%">
                    <el-row class="head-search">
                        <div style="margin: 10px 0; display: flex" class="search-radio fs-big">
                            <div>
                                <div class="title">日期:</div>

                                <el-radio-group v-model="order_fixed_time_value" size="small" @change="dataChange">
                                    <el-radio label="" border style="margin-right: 40px"> 全部 </el-radio>

                                    <el-radio label="yesterday" border style="margin-right: 40px">昨天 </el-radio>

                                    <el-radio label="between" border style="margin-right: -9px">自定义时间: </el-radio>
                                </el-radio-group>
                            </div>

                            <el-date-picker
                                v-if="order_fixed_time_value == 'between'"
                                v-model="order_time_array"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width: 426px"
                                @change="timeChange('order')"
                            >
                            </el-date-picker>
                        </div>
                    </el-row>
                    <el-row class="head-search">
                        <el-col :span="7">
                            <span class="title">状态:</span>

                            <el-select
                                v-model="search_data.status"
                                placeholder="请选择状态"
                                clearable
                                style="width: 150px"
                                @keyup.enter.native="searchDriverTaskProcessLists"
                            >
                                <el-option label="全部" value=""> </el-option>
                                <el-option label="未完成" value="0"> </el-option>
                                <el-option label="完成未发放" value="1"> </el-option>
                                <el-option label="发放未收回" value="2"> </el-option>
                                <el-option label="收回" value="3"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="7">
                            <span class="title">司机手机号:</span>
                            <!-- 搜索司机手机号 -->
                            <el-input
                                v-model="search_data.driver_phone"
                                placeholder="请输入司机手机号"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverTaskProcessLists"
                            ></el-input>
                        </el-col>
                        <el-col :span="7">
                            <span class="title">司机姓名:</span>
                            <!-- 搜索司机姓名 -->
                            <el-input
                                v-model="search_data.driver_name"
                                placeholder="请输入司机姓名"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverTaskProcessLists"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>
                <!-- 奖励发放审核次数等数据统计 -->

                <div class="amountNum">
                    <dir class="line"></dir>
                    <div class="left">
                        <div class="up" style="margin-bottom: 30px">
                            <div class="child">
                                <div style="font-weight: 700; font-size: 16px">总览</div>
                            </div>
                            <div class="child">
                                <div>奖励金</div>
                                <div>{{ all_data.reward_amount }}</div>
                            </div>
                            <div class="child">
                                <div>优享券</div>
                                <div>{{ all_data.reward_priority }}</div>
                            </div>
                            <div class="child">
                                <div>表现分</div>
                                <div>{{ all_data.reward_monitor }}</div>
                            </div>
                        </div>
                        <div class="up" style="margin-top: -10px">
                            <div class="child">
                                <div style="font-weight: 700; font-size: 16px">已发</div>
                            </div>
                            <div class="child">
                                <div>奖励金</div>
                                <div>{{ send_data.reward_amount }}</div>
                            </div>
                            <div class="child">
                                <div>优享券</div>
                                <div>{{ send_data.reward_priority }}</div>
                            </div>
                            <div class="child">
                                <div>表现分</div>
                                <div>{{ send_data.reward_monitor }}</div>
                            </div>
                        </div>
                        <div class="up" style="margin-top: 10px">
                            <div class="child">
                                <div style="font-weight: 700; font-size: 16px">待发</div>
                            </div>
                            <div class="child">
                                <div>奖励金</div>
                                <div>{{ wait_data.reward_amount }}</div>
                            </div>
                            <div class="child">
                                <div>优享券</div>
                                <div>{{ wait_data.reward_priority }}</div>
                            </div>
                            <div class="child">
                                <div>表现分</div>
                                <div>{{ wait_data.reward_monitor }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchDriverTaskProcessLists">搜索</el-button>
        </div>

        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            row-key="id"
            :tree-props="{ children: 'loop_list', hasChildren: 'hasChildren' }"
        >
            <el-table-column prop="driver_name" label="司机姓名" min-width="140" key="g"> </el-table-column>

            <el-table-column prop="driver_phone" label="司机手机号" min-width="100" key="h"> </el-table-column>
            <el-table-column prop="receipt_date" label="任务日期" min-width="100" key="m"> </el-table-column>
            <el-table-column key="b" prop="condition_time_sum" label="在线时长" min-width="100"> </el-table-column>
            <el-table-column key="c" prop="condition_order_sum" label="完成单数" min-width="100"> </el-table-column>
            <el-table-column prop="condition_recruitment_sum" label="招募司机" min-width="100" key="L"> </el-table-column>
            <el-table-column key="e" prop="condition_online_pay_sum" label="在线支付单数" min-width="100"> </el-table-column>

            <!-- <el-table-column prop="" label="奖励类型" min-width="90" key="f">
                <template slot-scope="scope">
                    <div v-if="Number(scope.row.reward_amount) > 0">现金</div>
                    <div v-if="Number(scope.row.reward_priority_num) > 0">优享券</div>
                    <div v-if="Number(scope.row.reward_monitor) > 0">表现分</div>
                </template>
            </el-table-column> -->
            <el-table-column prop="reward_priority_num" label="奖励" min-width="90" key="i">
                <template slot-scope="scope">
                    <div v-if="scope.row.reward_amount > 0">现金：{{ scope.row.reward_amount }}</div>
                    <div v-if="scope.row.reward_priority_num > 0">优享券：{{ scope.row.reward_priority_num }}</div>
                    <div v-if="scope.row.reward_monitor > 0">表现分：{{ scope.row.reward_monitor }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="90" key="j"> </el-table-column>

            <!-- <el-table-column key="a" prop="finish_stamp" label="完成时间" min-width="100"
                ><template slot-scope="scope">{{ scope.row.finish_stamp }} </template>
            </el-table-column> -->

            <!-- <el-table-column prop="reward_amount" label="奖励类型" min-width="100">
                <template slot-scope="scope"
                    >{{
                        Number(scope.row.reward_monitor) > 0
                            ? '表现分'
                            : Number(scope.row.reward_amount) > 0
                            ? '现金'
                            : Number(scope.row.reward_priority_num) > 0
                            ? '优享券'
                            : ''
                    }}
                </template>
            </el-table-column> -->

            <el-table-column prop="loop_time" label="时间段" min-width="90" key="kk"> </el-table-column>

            <el-table-column prop="reward_stamp" label="发放日期" min-width="90" key="k"> </el-table-column>
            <el-table-column key="d" label="完成订单" width="180" align="center">
                <template slot-scope="scope">
                    <!-- 子级查看订单按钮 -->
                    <el-button type="" v-if="!scope.row.loop_list" size="mini" @click="viewRouter(scope.row, scope.row.parent)"
                        >查看订单
                    </el-button>
                    <!-- 点击父级的查看订单 -->
                    <el-button v-if="scope.row.loop_list" type="success" size="mini" @click="viewRouter(scope.row)">查看订单 </el-button>
                </template>
            </el-table-column>

            <!-- <el-table-column
                v-if="Number(condition_order) > 0 || Number(condition_online_pay) > 0"
                key="d"
                label="完成订单"
                width="180"
                align="center"
            >
                <template slot-scope="scope">
        
                    <el-button type="" size="mini" @click="viewRouter(scope.row)">查看订单 </el-button>
                    
                </template>
            </el-table-column> -->
            <el-table-column label="操作" min-width="150">
                <template slot-scope="scope">
                    <!-- 只有手动审核且审核状态为未审核才显示审核按钮 -->
                    <!-- 如果当前行是树形表格的父级，则显示审核按钮  活动结束日期大于当前日期(_this.endData>_this.currentDate) 活动关闭，都不可以审核-->
                    <el-button
                        v-if="endData>currentDate&&scope.row.loop_list && scope.row.is_reviewed == '1' && scope.row.reward_status == '0' && data.status == '1'"
                        type="primary"
                        size="mini"
                        @click="driverTaskNewReward(scope.row)"
                        >审核
                    </el-button>
                    <div style="background-color: #fef0f0;color:#f56c6c;width:100px;border:1px solid #fde2e2;border-radius:5px;padding:5px" v-if="scope.row.reward_status == '2'" type="danger">已拒绝 ({{ scope.row.remarks }})</div>
                    <div style="background-color: #f0f9eb;color:#67c23a;width:100px;height:36px;line-height:24px;border:1px solid #e1f3d8;border-radius:5px;padding:5px" v-if="scope.row.reward_status == '1' && scope.row.remarks !== ''" type="success"
                        >已同意 {{scope.row.remarks }}</div
                    >
                    <div style="background-color: #f0f9eb;color:#67c23a;width:60px;height:36px;line-height:24px;text-align:center;border:1px solid #e1f3d8;border-radius:5px;padding:5px" v-if="scope.row.remarks == '' && scope.row.reward_status == '1'" type="success"
                        >已同意</div
                    >
                </template>
            </el-table-column>
        </el-table>

        <!-- 查看组件 -->
        <viewTaskDrawer :isShow="view_isShow" :data="driver_order_children" :parent="parent"></viewTaskDrawer>
        <!-- 审核组件 -->
        <examineDrawer :isShow="examine_isShow" :data="postData" @onSubmit="refreshData"></examineDrawer>

        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
        <div style="width: 200px; margin: 20px auto">
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
let _this;
import viewTaskDrawer from './viewTaskDrawer.vue';
import examineDrawer from './examineDrawer.vue';
export default {
    components: {
        viewTaskDrawer,
        examineDrawer
    },
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.currentDate = new Date();
            _this.endData = new Date(_this.data.end_date);

            _this.driverTaskReward();
            _this.driver_task_record_code_array = [];
            _this.search_data.driver_task_code = _this.data.driver_task_code;
            _this.searchDriverTaskProcessLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,
            currentDate:'',
            endData:'',
            parent: null,
            all_data: {}, //总览
            send_data: {}, //已发
            wait_data: {}, //待发
            condition_order: '',
            condition_time: '',
            condition_online_pay: '',
            batch: false, //是否为批量审核
            total: {
                pass_amount: '',
                pass_num: '',
                refuse_amount: '',
                refuse_num: '',

                wait_amount: '',
                wait_num: ''
            },
            // 传入子组件的数据
            driver_order_children: {},
            driver_code: '',
            driver_task_record_code_array: [],
            view_isShow: false,
            examine_isShow: false,
            postData: {},
            postData_batch: '',
            order_fixed_time_value: '',
            // 预约自定义时间
            order_time_array: [],

            search_data: {
                page: 1,
                limit: 10,
                driver_task_code: '',
                fixed_time: '',
                driver_phone: '',
                driver_name: '',
                status: ''
            },

            tableData: [],
            result_data: {}
        };
    },
    methods: {
        // 审核数据后刷新表格
        refreshData() {
            _this.driverTaskReward();
            _this.searchDriverTaskProcessLists();
        },
        // 审核按钮
        driverTaskNewReward(val) {
            console.log(val,'val');
            _this.postData = val;
            _this.examine_isShow = !_this.examine_isShow;
        },
        // 右上角概览
        driverTaskReward() {
            _this.$post('/task_new/driverTaskNewStatisticSum', { driver_task_code: _this.data.driver_task_code }).then((res) => {
                _this.all_data = res.data.all.all_data;
                _this.send_data = res.data.all.send_data;
                _this.wait_data = res.data.all.wait_data;
                _this.condition_order = res.data.condition_order;
                _this.condition_time = res.data.condition_time;
                _this.condition_online_pay = res.data.condition_online_pay;
            });
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.currentDate='';
            _this.endData='',

            _this.parent = null;
            _this.all_data = {};
            _this.send_data = {};
            _this.wait_data = {};
            _this.condition_order = '';
            _this.condition_time = '';
            _this.condition_online_pay = '';
            _this.batch = false;
            _this.total = {
                pass_amount: '',
                pass_num: '',
                refuse_amount: '',
                refuse_num: '',

                wait_amount: '',
                wait_num: ''
            };
            _this.driver_order_children = {};
            _this.driver_code = '';
            _this.driver_task_record_code_array = [];
            _this.postData = {};
            _this.postData_batch = '';
            _this.order_fixed_time_value = '';
            _this.order_time_array = [];
            _this.search_data = {
                page: 1,
                limit: 10,
                driver_task_code: '',
                fixed_time: '',
                driver_phone: '',
                driver_name: '',
                status: ''
            };
            _this.tableData = [];
            _this.result_data = {};
        },
        clearDriverTaskArray() {
            //清空表格选择数据
            _this.driver_task_record_code_array = [];
        },
        // 查看订单
        viewRouter(val, parent) {
            _this.view_isShow = !_this.view_isShow;
            _this.driver_order_children = val;
            _this.parent = parent;
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.driverTaskProcessLists();
        },

        // 查询条件日期
        dataChange(val) {
            _this.order_time_array = [];

            _this.search_data.fixed_time = [];
            if (val == 'between') {
            } else if (val == '') {
            } else {
                _this.search_data.fixed_time.push(_this.order_fixed_time_value);

                _this.search_data.fixed_time = JSON.stringify(_this.search_data.fixed_time);
            }
        },

        // 搜索时间选择触发
        timeChange(parm, val) {
            if (_this.order_time_array == null) {
                _this.search_data.fixed_time = [];
            } else {
                _this.search_data.fixed_time = JSON.stringify(['between'].concat(_this.order_time_array));
            }
        },
        // 搜索
        searchDriverTaskProcessLists() {
            _this.search_data.page = 1;
            _this.driverTaskProcessLists();
        },
        driverTaskProcessLists() {
            _this.$post('/task_new/driverTaskNewStatisticLists', _this.search_data).then((res) => {
                _this.result_data = res;
                _this.tableData = res.data;
      
                if (_this.tableData.length > 0) {
                    // 遍历table数据，往loop_list中每项数据添加“id”的键值
                    for (let index = 0; index < _this.tableData.length; index++) {
                        
                        for (let i = 0; i < _this.tableData[index].loop_list.length; i++) {
                            _this.tableData[index].loop_list[i].id = _this.tableData[index].id + String(i);
                            // el-table 树形结构，子节点拿到父级的数据 每个节点都追加一个parent属性，它指向该节点的直接父节点。
                            _this.tableData[index].loop_list[i].parent = _this.tableData[index]; // 点击表格子节点的查看订单需要拿到父节点数据，这个parent用来存放父节点数据
                        }
                    }
                }
          
                _this.total = res.data.total;
            });
        }
    }
};
</script>

<style scoped>
.child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.up {
    display: flex;
}
.left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}
.amountNum {
    display: flex;
    justify-content: space-between;
    width: 30%;
    margin-bottom: 10px;
}
.line {
    background-color: #909399;
    width: 1px;
}
.child > div {
    margin-right: 20px;
    margin-bottom: 10px;
}
.pagination {
    text-align: right;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>

